import Script from "next/script";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace React.JSX {
    export interface IntrinsicElements {
      "jl-reviews-subrating-review": {
        "data-testid"?: string;
        productId: string;
        apiKey: string;
        clientId: string;
        subrating: string;
        reviewsId: string;
        includeCoreAssets?: boolean;
        isBrandPromiseActive?: boolean;
        experiments?: string | null;
        noMargin?: boolean;
      };
    }
  }
}

type Props = {
  productId: string;
  reviewsApiKey: string;
  reviewsSubratingScriptUrl: string;
};

export const TrueToSizeBlockUI = ({
  productId,
  reviewsApiKey,
  reviewsSubratingScriptUrl,
}: Props) => (
  <div data-component="TrueToSizeBlock">
    <jl-reviews-subrating-review
      data-testid="subrating-reviews"
      productId={productId}
      apiKey={reviewsApiKey}
      clientId={"web-pdp-scaffold-ui"}
      subrating={"fit"}
      reviewsId={"ratings-reviews-section"}
      isBrandPromiseActive={true}
      experiments={null}
      data-component="TrueToSizeBlock"
      noMargin={true}
    />
    <Script
      data-testid={"subrating-reviews-script"}
      type={"text/javascript"}
      src={reviewsSubratingScriptUrl}
    />
  </div>
);
